import { filterBarTemplate} from "../templates";
import { FilterBarDropdown } from "./filter-dropdown";
import { TermBadge } from "./term-badge";
var FilterBar = Backbone.View.extend({
    tagName: 'div',
    className: 'filter-bar',
    events: {
        'click .sort': 'sortClick',
        'click a.reset': 'resetGrid',
        'click a.filter': 'filterGrid',
        'click a.clear-filters' : 'resetFilters',
        'click a.show-mobile-filters': 'toggleMobileFilters'
    },
    initialize: function(){
        _.bindAll( this, 'render', 'sortClick', 'sortGrid', 'initialSortCallback', 'filterGrid', 'resetGrid', 'updateFilterSettings', 'addFilterInput', 'showSelected', 'addTermBadge', 'updateCount', 'resetFilters', 'updateFilterOptions', 'updateSubheading', 'updateSortLabel', 'toggleMobileFilters' );
        
        this.mobileFiltersOpen = false;
        this.selection = [];
        this.listenTo( this.model, 'change:count', this.updateCount );
        this.listenTo( this.model, 'change:label', this.updateSubheading );
        
        this.listenTo( this.model, 'change:sort_label', this.updateSortLabel );

        this.listenTo( this.model, 'settings_updates', this.render );
        this.render();
        this.initialSortCallback();
    },
    toggleMobileFilters: function( e ){
        e.preventDefault();
        this.mobileFiltersOpen = !this.mobileFiltersOpen;
        if ( this.mobileFiltersOpen ) {
            this.$(e.currentTarget).text( 'Hide Filters' );
        } else {
            this.$(e.currentTarget).text( 'Show Filters' );
        }
        this.$el.toggleClass( 'mobile-filtering' );
    },
    /*
    handle the first sort, if it is default we can bail out early.
    */
    initialSortCallback: function (){
        let key = this.model.get( 'sort_key' );
        if ( key == 'order' ) {
            return;
        } else {
            var order = this.model.get( 'sort_order' );
            var label = this.$('.sort[data-sort="'+key+':'+order+'"]').text();
            this.model.set({ 'sort_label' : label });
            this.sortGrid( key, order );
        }
    },
    /*
    Update the sort label
    */
    updateSortLabel: function(){
        let sortLabel = this.model.get( 'sort_label' );
        this.$('.sort-label').text( sortLabel );
    },
    /*
    Update the product count indicator
    */
    updateCount: function(){
        var count = this.collection.where({'visible' : true }).length;
        this.$(".product-count").text( count );
    },

    /*
    Update the subheading
    */
    updateSubheading: function(){
        var label = this.model.get('label');
        if ( label == null ) {

            this.stopListening( this.model, 'change:label', this.updateSubheading );
            label = 'Products';
            this.model.set({'label': label});
            this.listenTo( this.model, 'change:label', this.updateSubheading );
        }
        this.$("h2").text( label );
    },
    /*
    Trigger the update of the filter badges, currently not in use
    */
    updateFilterOptions: function(){
        this.showSelected();
    },
    /*
    Render the view markup, called on the filter model event 'settings_updates'
    */
    render: function(){

        var productCount = this.collection.where(  {'visible' : true } ).length;
        this.model.set( { 'count' : productCount } );
        let x = this.model.toJSON();
        let html = filterBarTemplate( x );
        this.el.innerHTML = html;
        var options = this.model.get( 'filter_options' );

        options.each( this.addFilterInput );
        this.showSelected();
        
    },
    /* 
    Add the appicable filter inputs to the filter bar. Checks conditions to remove them if necessary
    */
    addFilterInput: function( opt ){ 
        var conditions = opt.get( 'conditions' );
        if ( ! _.isEmpty(conditions) ) {
            // make sure the conditions are met
            var filter_settings = this.model.get( 'filter_settings' );
            var conds = Object.keys( conditions );
            var key, x, val, dropdown;
            // for each condition
            for ( var i = 0; i < conds.length; i++ ) {
                key = conds[i];
                val = filter_settings[key];
                if ( _.isEmpty( val ) ) {
                    // not set so can't meet this condition
                    continue;
                }
                x = conditions[key];
                // if it is an array, check if the filter setting is in the array
                if ( _.isArray( x ) && ! x.includes( filter_settings[key] ) ) {
                    continue;
                } else if ( !_.isArray( x ) && x !== val ) {
                    // if it is a string|bool, check that filter setting matches that val
                    continue;
                }
                // if we get here, add the option.
                dropdown = new FilterBarDropdown({ model: opt });
                this.$(".available").append( dropdown.el );
            }
        } else {
            dropdown = new FilterBarDropdown({ model: opt });
            this.$(".available").append( dropdown.el );
        }
    },

    /*
    Will eventually house the sorting calback function
    */
    sortClick: function( e ){
        e.preventDefault();
        
        var sortVal = e.currentTarget.dataset.sort.split( ':' );
        this.model.set({'sort_label': e.target.innerText, 'sort_key' : sortVal[0], 'sort_order' : sortVal[1] });
        this.sortGrid( sortVal[0], sortVal[1] );
        // this.collection.sortBy( 'name' );
    },
    sortGrid: function ( key, order ){
        this.collection.sort_key = key;
        this.collection.sort_order = order == 'asc' ? 1 : -1;
        this.collection.sort();
        this.collection.trigger( 'sorted' );
    },
    /*
    Set the product grid back to the original state.
    */
    resetGrid: function(){
        this.collection.each(function( model ){
            model.set( { visible: true } );
            model.updateViewProps( {} );
        });
        var productCount = this.collection.where(  {'visible' : true } ).length;
        this.model.set( { 'count' : productCount } );
        this.collection.trigger( 'filtered' );
    },
    /*
    iterate over the products, setting them to visible or not based on the filters.
    */
    filterGrid: function(){
        //  window.debugLogger( filteredTerms );
        var filter_settings = this.model.get('filter_settings');
        var filter_keys =  Object.keys( filter_settings );
        // loop over the collection
        var i, y, selected_filter;
        for( var f=0; f < this.collection.length; f++) {
            let item = this.collection.at( f );
            // foreach product
            let visiblity = true;
            let settings = item.get( 'filters' );

            for ( i = 0; i < filter_keys.length; i++ ) {
                y = filter_keys[i];
                selected_filter = filter_settings[y];

                if ( _.isNull( selected_filter ) ) {
                    continue;
                }
                if ( _.isArray( settings[y] ) && settings[y].includes( selected_filter ) ) {
                    continue;
                } else if ( selected_filter === true && settings[y] !== selected_filter ) {
                    visiblity = false;
                } else if ( settings[y] !== selected_filter ) {
                    visiblity = false;
                }
                if ( ! visiblity ) {
                    break;
                }
            }

            // set visible on item model
            item.set( {'visible' : visiblity } );
            item.updateViewProps( filter_settings );
            
        }
        // sort the collection
        var productCount = this.collection.where(  {'visible' : true } ).length;
        this.model.set( { 'count' : productCount } );
        this.collection.trigger( 'filtered' );
    },
    /*
    Shows the selected filters in a pill badge UI
    */
    showSelected: function(){

        this.$(".selected a.clear-filters").remove();
        if ( this.selection.length ) {
            _.each( this.selection, function(view) {
                view.model.destroy();
                view.remove();
            });
            this.selection = [];
        }
        var settings = this.model.get( 'filter_settings' );

        _.each( settings, this.addTermBadge );

        if ( this.selection.length ) {
            this.$(".selected").append( '<a href="#" class="clear-filters">Clear all filters</a>' );
        } 
        this.filterGrid();
    },
    /*
    Clear all the filters
    */
    resetFilters: function( e ){
        e.preventDefault();
        var settings = this.model.get( 'filter_settings' );
        _.each( this.selection, function(view) {
            view.model.destroy();
            view.remove();
        });
        _.each( settings, function( v, k ){
            settings[k] = null;
        } );
        this.model.set( { 'filter_settings': settings } );
        var options = this.model.get('filter_options');
        options.each(function(o){
            o.clearOption();
        });
        this.render();
        this.resetGrid();
        this.model.trigger( 'settings_updates' );
    },
    /*
    Create a view for individual filter term pill badges
    */
    addTermBadge: function( term, key ){
        if ( term ) {
            let badgeModel = new Backbone.Model( { 'name': term, 'key' : key } );
            this.listenTo( badgeModel, 'removing', this.updateFilterSettings );
            let badge = new TermBadge( { model: badgeModel } );
            this.$(".selected").append( badge.el );
            this.selection.push( badge );
        }
    },
    /*
    Triggered when a filter term pill badge is removed.
    */
    updateFilterSettings: function( model ){
        var key = model.get( 'key' );
        var term = model.get( 'name' );
        var filter_settings = this.model.get('filter_settings');
        filter_settings[key] = null;
        this.model.set( { 'filter_settings': filter_settings } );
        var filter_options = this.model.get('filter_options');

        // deselect the opt
        var opt = filter_options.findWhere({ 'key' : key });
        opt.set({'selection': null });

        // deselect the term
        var terms = opt.get('terms');
        var t = terms.findWhere({ 'value': term });
        t.set({'selected' : false });

        this.stopListening( model, 'removing', this.updateFilterSettings );
        this.model.trigger( 'settings_updates' );
    }
});

export {FilterBar};